import React from "react";
import "./Search.css";
import Button from "../../../../Button"

function index() {
  return (
    <div className="search">
      <h1>Find Adventure That Suits Your Needs</h1>
      <form action="">
          {/* <input type="text" name="" id="inputSearch" placeholder="Where to?" /> */}
          <select name="" id="">
            <option value="tashkent">Tashkent</option>
            <option value="samarkand">Samarkand</option>
            <option value="bukhara">Bukhara</option>
            <option value="khiva">Khiva</option>
            <option value="termez">Termez</option>

          </select>
          <select name="data"  id="data">
              <option value="january">January</option>
              <option value="february">February</option>
              <option value="march">March</option>
              <option value="april">April</option>
              <option value="may">May</option>
              <option value="june">June</option>
              <option value="july">July</option>
              <option value="august">August</option>
              <option value="september">September</option>
              <option value="october">October</option>
              <option value="november">November</option>
              <option value="december">December</option>
          </select>
          <select name="type" id="type">
              <option value="travelling">Travel</option>
              <option value="vacation">Vacation</option>
              <option value="adventure">Adventure</option>
              <option value="budget">Budget</option>

          </select>
          <Button title="Submit" />
      </form>
    </div>
  );
}

export default index;
